import {Component, Input, OnInit} from '@angular/core';
import {debounceTime} from 'rxjs/operators';
import {SelfEmployedAddbackModel} from '../../../models/widgets/employment-details-model';
import {FormBuilderService, TypesService} from '../../../services';
import {WizardWidgetComponent} from '../wizard-widget/wizard-widget.component';
import * as uuid from 'uuid';
import Decimal from 'decimal.js';
import { UntypedFormArray, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {noSameValues} from '../../../_global/validators/custom-validators.directive';
import {DataHandlerService} from '../../../services/data-handler.service';
import { MatIconModule } from '@angular/material/icon';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { ValidationPartialComponent } from '../partials/validation-partial.component';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgIf, NgFor, NgClass } from '@angular/common';
import {
  MatInputCommifiedDirective
} from '../../../../../firstmac-material-lib/projects/fmc-elements/src/lib/commified/mat-input-commified-directive';

@Component({
    selector: 'app-self-employed-details',
    templateUrl: './self-employed-details.component.html',
    standalone: true,
    imports: [NgIf, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatFormFieldModule, MatInputModule, MatInputModule,
      ValidationPartialComponent, MatButtonModule, MatButtonModule, NgFor, NgClass, MatSelectModule, MatSelectModule,
      MatOptionModule, MatOptionModule, MatIconModule, MatInputCommifiedDirective]
})
export class SelfEmployedDetailsComponent extends WizardWidgetComponent implements OnInit {
  @Input() formGroup;
  @Input() personList;
  @Input() formGroupFormArray;

  public incomeSourceTypeSlug = 'income-source-types';

  public debtServiceAddbacksTypes = [];

  constructor(public dataHandlerService: DataHandlerService,
    private typesService: TypesService,
    private formBuilderService: FormBuilderService
  ) {
    super(dataHandlerService);
  }

  async ngOnInit() {
    this.formGroup.get('allowableAddBacks').setValidators(noSameValues('addbackType', [{
      'name': 'other-company',
      maxCount: 2
    }]));

    super.ngOnInit();
    Promise.all([
      this.populateIncomeSourceTypes()
    ]);

    this.formGroup.get('previousYearIncome').valueChanges
      .pipe(debounceTime(300))
      .subscribe((result: any) => {
        console.debug('SelfEmployedDetailsComponent.currentYearIncome.valueChanges');
        this.calculateSelfEmployedIncome(this.formGroup);
      });

    this.formGroup.get('currentYearIncome').valueChanges
      .pipe(debounceTime(300))
      .subscribe((result: any) => {
        console.debug('SelfEmployedDetailsComponent.currentYearIncome.valueChanges');
        this.calculateSelfEmployedIncome(this.formGroup);
      });

    this.calculateSelfEmployedIncome(this.formGroup);
  }

  public populateIncomeSourceTypes() {
    return this.typesService.getTypesList(this.incomeSourceTypeSlug)
      .then(results => {
        this.debtServiceAddbacksTypes = results.filter(x => x.ext.incomeCategory === 'addback');
      });
  }

  addAddback(formGroup) {
    const fg = this.formBuilderService.convertObjectToFormGroup(new SelfEmployedAddbackModel());
    this.formBuilderService.setValidationRules(new SelfEmployedAddbackModel(), fg);

    fg.get('addbackLink').patchValue(uuid.v1());

    fg.get('addbackCurrentYearIncome').valueChanges.pipe(
      debounceTime(300))
      .subscribe((result: any) => {
        console.debug('SelfEmployedDetailsComponent.addbackCurrentYearIncome.valueChanges');
        this.calculateSelfEmployedIncome(formGroup);
      });

    fg.get('addbackPreviousYearIncome').valueChanges.pipe(
      debounceTime(300))
      .subscribe((result: any) => {
        console.debug('SelfEmployedDetailsComponent.addbackPreviousYearIncome.valueChanges');
        this.calculateSelfEmployedIncome(formGroup);
      });

    formGroup.get('allowableAddBacks').push(fg);
  }

  removeAddback(formGroup, i) {
    const arrayControl = formGroup.get('allowableAddBacks') as UntypedFormArray;
    arrayControl.removeAt(i);

    this.calculateSelfEmployedIncome(formGroup);
  }

  calculateSelfEmployedIncome(formGroup) {
    let currentYearTotal = 0;
    let previousYearTotal = 0;

    try {
      currentYearTotal = new Decimal(currentYearTotal).add(formGroup.value.currentYearIncome || 0).toNumber();
      previousYearTotal = new Decimal(previousYearTotal).add(formGroup.value.previousYearIncome || 0).toNumber();

      if (formGroup.value.allowableAddBacks && formGroup.value.allowableAddBacks.length > 0) {
        formGroup.value.allowableAddBacks.forEach((addBack: any, index: number) => {
          currentYearTotal = new Decimal(currentYearTotal || 0).add(addBack.addbackCurrentYearIncome || 0).toNumber();
          previousYearTotal = new Decimal(previousYearTotal || 0).add(addBack.addbackPreviousYearIncome || 0).toNumber();

          if (formGroup.value.allowableAddBacks.length === (index + 1)) {
            formGroup.get('currentYearTotalIncome').patchValue(currentYearTotal);
            formGroup.get('previousYearTotalIncome').patchValue(previousYearTotal);
          }
        });
      } else {
        formGroup.get('currentYearTotalIncome').patchValue(currentYearTotal);
        formGroup.get('previousYearTotalIncome').patchValue(previousYearTotal);
      }
    } catch (e) {
      console.log('Error trying to calculate SE income', e);
    }
  }

}
